import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { GetGlycerinPriceFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetGlycerinPriceFragmentFragmentDoc';

/* GraphQL */ `
  fragment GetGlycerinPriceFragment on ProductPrice {
    value
    valueOld
    currency
  }
`;

export type GetGlycerinPriceProps = FragmentType<typeof GetGlycerinPriceFragmentFragmentDoc>;

export const getGlycerinPrice = (price: GetGlycerinPriceProps) => {
  const { currency, value, valueOld } = getFragmentData(GetGlycerinPriceFragmentFragmentDoc, price);

  return {
    displayedPrice: value,
    currency,
    originalPrice: valueOld || undefined,
  };
};
